import React from "react"
import { graphql, Link } from "gatsby"
import { getImage, getSrc } from "gatsby-plugin-image"
import { RichText } from "prismic-reactjs"
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import styled from 'styled-components'

import LayoutUpdate from "../components/layout-update"
import Seo from "../components/seo"
import HeroSection from "../components/common/hero-section"
import htmlSerializer from "../utils/htmlSerializer"

const StyledDiv = styled.div`
  background-color: #1ea0a0;
`

const ProductGuidePageTemplate = ({ data }) => {
  const doc = data.prismicProductGuidePage
  const imgSrc = getSrc(doc.data.page_hero_background)
  const imgHero = getImage(doc.data.page_hero_background)
  const sectionButtonOneLinkType = doc.data.section_cta_button_link.link_type
  const sectionButtonOneLinkUid = doc.data.section_cta_button_link.uid
  const sectionButtonOneLinkUrl = doc.data.section_cta_button_link.url

  return (
    <LayoutUpdate>
      <Seo
        title={doc.data.page_title ? doc.data.page_title : null}
        description={doc.data.page_short_description ? doc.data.page_short_description : null}
        image={imgSrc ? imgSrc : null}
      />

      <HeroSection
        title={doc.data.page_title ? doc.data.page_title : 'Page Title'}
        imgSrc={imgHero}
      />

      <StyledDiv className="py-20">
        <div className="intro-section w-11/12 lg:w-10/12 max-w-screen-lg mx-auto md:px-12">
          {doc.data.intro_section_content
            ? 
            <RichText
              render={doc.data.intro_section_content.richText}
              htmlSerializer={htmlSerializer}
            />
            : 
            <p className="text-white text-lg md:text-xl text-center md:px-12 mb-6">Intro section content here and more..</p>
          }
        </div>

        <div className="relative w-11/12 max-w-screen-xl flex flex-col items-center justify-center mx-auto z-10 mt-12">
          {doc.data.section_cta_button_one_type
            ?
            <div className='mt-8 mb-0'>
              <div className="hidden xl:flex flex-col items-center justify-center">
                {sectionButtonOneLinkType === "Document" || sectionButtonOneLinkType === "Any"
                  ?
                  <Link to={sectionButtonOneLinkUid ? `/${sectionButtonOneLinkUid}` : "/"}>
                    <button id="qualify-button" className="w-full md:w-auto bg-site-red hover:bg-site-red-hover text-base md:text-lg text-white uppercase tracking-wider px-12 py-3">
                      <span className="default-text mx-2">{doc.data.section_cta_button_text ? doc.data.section_cta_button_text : "Button Name"}</span>
                      <span className="hover-text">{doc.data.section_cta_button_one_hover_text ? doc.data.section_cta_button_one_hover_text : "Button Name Hover"}</span>
                    </button>
                  </Link>
                  :
                  sectionButtonOneLinkType === "Web" || sectionButtonOneLinkType === "Media"
                  ?
                  <a
                    href={sectionButtonOneLinkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button id="qualify-button" className="w-full md:w-auto bg-site-red hover:bg-site-red-hover text-base md:text-lg text-white uppercase tracking-wider px-12 py-3">
                      <span className="default-text mx-2">{doc.data.section_cta_button_text ? doc.data.section_cta_button_text : "Button Name"}</span>
                      <span className="hover-text">{doc.data.section_cta_button_one_hover_text ? doc.data.section_cta_button_one_hover_text : "Button Name Hover"}</span>
                    </button>
                  </a>
                  :
                  null
                }
              </div>

              <div className="xl:hidden flex flex-col items-center justify-center">
                <div className="mb-4">
                  <p className="text-site-red text-2xl font-semibold text-center tracking-wider mb-6">{doc.data.section_cta_button_text ? doc.data.section_cta_button_text : "Button Name"}</p>
                  {sectionButtonOneLinkType === "Document" || sectionButtonOneLinkType === "Any"
                    ?
                    <Link to={sectionButtonOneLinkUid ? `/${sectionButtonOneLinkUid}` : "/"}>
                      <button className="w-full md:w-auto bg-site-red hover:bg-site-red-hover text-base md:text-lg text-white uppercase tracking-wider px-14 py-3">
                        <span className="mx-1">{doc.data.section_cta_button_one_hover_text ? doc.data.section_cta_button_one_hover_text : "Button Name Hover"}</span>
                      </button>
                    </Link>
                    :
                    sectionButtonOneLinkType === "Web" || sectionButtonOneLinkType === "Media"
                    ?
                    <a
                      href={sectionButtonOneLinkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="w-full md:w-auto bg-site-red hover:bg-site-red-hover text-base md:text-lg text-white uppercase tracking-wider px-24 py-3">
                        <span className="mx-1">{doc.data.section_cta_button_one_hover_text ? doc.data.section_cta_button_one_hover_text : "Button Name Hover"}</span>
                      </button>
                    </a>
                    :
                    null
                  }
                </div>
              </div>
            </div>
            :
            <>
              {sectionButtonOneLinkType === "Document" || sectionButtonOneLinkType === "Any"
                ?
                <Link to={sectionButtonOneLinkUid ? `/${sectionButtonOneLinkUid}` : "/"}>
                  <button className="w-full mb-4 xl:mb-0 md:w-auto bg-site-red hover:bg-site-red-hover text-base md:text-lg text-white uppercase tracking-wider px-6 md:px-10 py-3">
                    {doc.data.section_cta_button_text ? doc.data.section_cta_button_text : "Button Name"}
                  </button>
                </Link>
                :
                sectionButtonOneLinkType === "Web" || sectionButtonOneLinkType === "Media"
                ?
                <a
                  href={sectionButtonOneLinkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="w-full mb-4 xl:mb-0 md:w-auto bg-site-red hover:bg-site-red-hover text-base md:text-lg text-white uppercase tracking-wider px-6 md:px-10 py-3">
                    {doc.data.section_cta_button_text ? doc.data.section_cta_button_text : "Button Name"}
                  </button>
                </a>
                :
                null
              }
            </>
          }
        </div>
      </StyledDiv>
    </LayoutUpdate>
  )
}

export default withPrismicPreview(ProductGuidePageTemplate)

export const ProductGuidePageTemplateNewQuery = graphql`
  query($id: String!) {
    prismicProductGuidePage(id: { eq: $id }) {
      _previewable
      id
      uid
      data {
        page_title
        page_short_description
        page_hero_background {
          gatsbyImageData(
            width: 1920
          )
        }
        intro_section_content {
          richText
        }
        section_cta_button_one_type
        section_cta_button_text
        section_cta_button_one_hover_text
        section_cta_button_link {
          uid
          link_type
          url
        }
      }
    }
  }
`